import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'
import { useAssignmentAccess } from '../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../constants/assignment-permissions'

const EditFunctionInTestModal = ({
    showEditFunctionInTestModal,
    setShowEditFunctionInTestModal,
    updateFunctionInUnitTest,
}) => {
    const [errorMessage, setErrorMessage] = useState('')
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return updateFunctionInUnitTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showEditFunctionInTestModal}
            setShowModal={setShowEditFunctionInTestModal}
            submitTest={handleSubmitTest}
            modalTitle={hasEditingPermission ? 'Update function in test' : 'View function in test'}
            submitButtonText='Update'
            fields={{
                name: true,
                input: true,
                functionName: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            readOnly={!hasEditingPermission}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showEditFunctionInTestModal: unitTests.showEditFunctionInTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowEditFunctionInTestModal: value => {
            dispatch(unitTestsActions.setShowEditFunctionInTestModal(value))
        },
        updateFunctionInUnitTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.updateFunctionInUnitTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(EditFunctionInTestModal)
